
import { Component, Prop, Vue } from "vue-property-decorator";
import MatchInterface from "@/libs/model/MatchInterface";

@Component({})
export default class DateComponent extends Vue
{
  @Prop() matchdata: MatchInterface;
  get date() {
    let dateTime = new Date(`${this.matchdata.matchInfo.date.replace('Z','')}T${this.matchdata.matchInfo.time}`);
    let dayMonth = new Intl.DateTimeFormat('en-SG', {month: 'short', day: 'numeric'}).format(dateTime);
    let year = dateTime.getFullYear();
    return `${dayMonth}, ${year}`;
  }

  get dateboxClass() {
    let dateTime = new Date(`${this.matchdata.matchInfo.date.replace('Z','')}T${this.matchdata.matchInfo.time}`);
    let todayDateTime = new Date();

    if(dateTime.getFullYear() === todayDateTime.getFullYear() && dateTime.getMonth() === todayDateTime.getMonth() && dateTime.getDate() === todayDateTime.getDate()){
      return 'datebox-default datebox-green';
    }
    return 'datebox-default';
  }
}
